import { ComplianceEntity } from "@wingspanhq/wingspan-api-sdk";

/**
 * The account's own compliance entity — the one without a `subject`. Entities
 * carrying a subject describe someone else (a beneficial owner, a counterparty),
 * so they are never the account holder.
 */
export const selectorPrimaryComplianceEntity = (
  entities: ComplianceEntity[] | undefined
): ComplianceEntity | undefined => entities?.find(entity => !entity.subject);
